import { CURRENCY_CODE } from "@/lib/constant";
import {
  getFormattedProductItems,
  getProductNames,
  getProductSKUs,
} from "@repo/lib/helpers";
import { useFeatureFlag } from "@repo/lib/hooks/common";
import { useCallback } from "react";

const useTrackCheckoutStarted = () => {
  const isWebEngageEnabled = useFeatureFlag("webEngage");
  const trackCheckoutStartedEvent = useCallback(
    (cartInfo) => {
      if (!isWebEngageEnabled) {
        console.warn("WebEngage feature is disabled");
        return;
      }
      if (window.webengage) {
        if (cartInfo) {
          const { cartTotal, couponName, itemsQuantity, lineItems } = cartInfo;
          const { total, tax, subTotal, shippingCharges, couponDiscount } =
            cartTotal;
          const eventData = {
            total,
            couponName,
            shippingCharges,
            discount: couponDiscount,
            tax,
            subTotal,
            product_id: getProductSKUs(lineItems),
            product_names: getProductNames(lineItems),
            currency: CURRENCY_CODE,
            items: getFormattedProductItems(lineItems, couponName),
            no_of_product: itemsQuantity,
          };

          window.webengage.track("checkout_started", eventData);
        }
      } else {
        console.error("WebEngage is not defined");
      }
    },
    [isWebEngageEnabled]
  );

  return { trackCheckoutStartedEvent };
};

export default useTrackCheckoutStarted;
